module.exports = __webpack_public_path__ + "static/media/bestalla.db4b8ce0.mp3";